// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { ArrowRight as RawArrowRight } from "lucide-react";
export const ArrowRight = /* @__PURE__ */ createIcon(RawArrowRight, "ArrowRight", 2);
